import React from 'react';
import {Flex} from '../Flex';
import {Content} from '../Content';
import {Partners} from '../Partners';

export const SetupIntegration: React.FC = ({children}) => (
  <Content sx={{marginTop: '150px'}}>
    <Flex direction="column" justifyContent="center" style={{margin: 'auto', textAlign: 'center'}}>
      <div style={{textAlign: 'left', margin: 'auto'}}>{children}</div>
      <Partners />
    </Flex>
  </Content>
);
